module.exports = __webpack_public_path__ + "static/media/home_management_subscription.a0258393.svg";